import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { faFilter, faCircle, faCheckCircle, faExclamationCircle, faTimesCircle, faCheck } from '@fortawesome/free-solid-svg-icons'; // Import faCheck for the indicator
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './FilterButton.scss';

interface FilterButtonProps {
  onFilterChange: (filter: string) => void;
  currentFilter: string; // Add currentFilter prop to track the selected filter
}

const FilterButton: React.FC<FilterButtonProps> = ({ onFilterChange, currentFilter }) => {
  const handleFilterSelect = (filter: string) => {
    onFilterChange(filter);
  };

  return (
    <Dropdown className="filter-button-container">
      <Dropdown.Toggle variant="secondary" className="filter-button-review button-cancel">
        <FontAwesomeIcon icon={faFilter} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item className="color-filter-item" onClick={() => handleFilterSelect('')}>
          Visa alla {currentFilter === '' && <FontAwesomeIcon icon={faCheck} className="color-filter-check" />} {/* Indicator for "All" */}
        </Dropdown.Item>
        <Dropdown.Item className="color-filter-item" onClick={() => handleFilterSelect('green')}>
          <FontAwesomeIcon icon={faCheckCircle} className="color-filter-icon" style={{ color: '#07A235' }} />
          Under gränsvärden {currentFilter === 'green' && <FontAwesomeIcon icon={faCheck} className="color-filter-check" />} {/* Indicator for "Green" */}
        </Dropdown.Item>
        <Dropdown.Item className="color-filter-item" onClick={() => handleFilterSelect('yellow')}>
          <FontAwesomeIcon icon={faExclamationCircle} className="color-filter-icon" style={{ color: '#F5A32D' }} />
          Över gul {currentFilter === 'yellow' && <FontAwesomeIcon icon={faCheck} className="color-filter-check" />} {/* Indicator for "Yellow" */}
        </Dropdown.Item>
        <Dropdown.Item className="color-filter-item" onClick={() => handleFilterSelect('red')}>
          <FontAwesomeIcon icon={faTimesCircle} className="color-filter-icon" style={{ color: '#DC143C' }} />
          Över röd {currentFilter === 'red' && <FontAwesomeIcon icon={faCheck} className="color-filter-check" />} {/* Indicator for "Red" */}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FilterButton;
